/* Shared bottle-preview finish. Keep this tint out of production artwork:
 * engraving exports stay black on transparency. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.JEPersonalizationFinish = factory();
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  function metalColor(variant) {
    // This bottle photograph is darker than its lavender catalog swatch.
    // Use the same bright silver for every design on this bottle color.
    const name = String(variant?.color || '').trim().replace(/\s+/g, ' ').toLowerCase();
    if (name === 'out of the blue') return '#f4f6f8';
    const value = String(variant?.colorHex || '').trim();
    const hex = /^#[0-9a-f]{6}$/i.test(value) ? value.slice(1) : 'ffffff';
    const rgb = [0, 2, 4].map(i => parseInt(hex.slice(i, i + 2), 16) / 255);
    return .2126 * rgb[0] + .7152 * rgb[1] + .0722 * rgb[2] > .65 ? '#788288' : '#ccd1d5';
  }
  // The Studio's brushed-steel palette, mapped into physical board coordinates.
  // This is a preview-only material: the original black production mask is untouched.
  function lightSurface(variant) {
    if (String(variant?.color || '').trim().toLowerCase() === 'out of the blue') return false;
    const hex = String(variant?.colorHex || '').trim();
    if (!/^#[\da-f]{6}$/i.test(hex)) return /^(white|cream|ivory)$/i.test(String(variant?.color || '').trim());
    const channels = [1, 3, 5].map(start => parseInt(hex.slice(start, start + 2), 16) / 255)
      .map(value => value <= .04045 ? value / 12.92 : ((value + .055) / 1.055) ** 2.4);
    return channels[0] * .2126 + channels[1] * .7152 + channels[2] * .0722 >= .65;
  }
  function renderMetallic(mask, variant, options = {}) {
    const width = Number(options.board?.width || 60) * 5, height = Number(options.board?.height || 95) * 5;
    if (!mask?.width || !mask?.height || !(width > 0 && height > 0)) throw new Error('Invalid engraving preview mask.');
    const make = () => { const canvas = document.createElement('canvas'); canvas.width = mask.width; canvas.height = mask.height; return canvas; };
    const finish = make(), ctx = finish.getContext('2d'), dark = lightSurface(variant);
    ctx.save(); ctx.scale(mask.width / width, mask.height / height);
    const reflection = ctx.createLinearGradient(0, height * .72, width, height * .22);
    const stops = dark
      ? [[0, '#697278'], [.18, '#818b91'], [.39, '#a0a9ae'], [.49, '#b3bbc0'], [.59, '#98a2a8'], [.79, '#778289'], [1, '#929da4']]
      : [[0, '#969fa5'], [.18, '#bbc3c8'], [.39, '#e0e5e8'], [.49, '#f3f6f7'], [.59, '#d9dfe3'], [.79, '#aeb7bd'], [1, '#d3dbe0']];
    stops.forEach(([position, color]) => reflection.addColorStop(position, color));
    ctx.fillStyle = reflection; ctx.fillRect(0, 0, width, height);
    let seed = 19427;
    for (let row = 0; row < height; row += 2) {
      seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0;
      ctx.fillStyle = seed & 1 ? 'rgba(255,255,255,0.11)' : 'rgba(61,75,85,0.055)';
      ctx.fillRect(0, row + (seed % 7) / 10, width, .45);
      ctx.fillStyle = 'rgba(255,255,255,0.055)';
      ctx.fillRect(seed % Math.max(1, width), row + .8, Math.max(8, width * .24), .35);
    }
    ctx.restore(); ctx.globalCompositeOperation = 'destination-in'; ctx.drawImage(mask, 0, 0);
    ctx.globalCompositeOperation = 'source-atop';
    const edge = make(), ec = edge.getContext('2d');
    [[.75, .75, '#58646d', .32], [-.65, -.65, '#ffffff', dark ? .3 : .7]].forEach(([x, y, color, opacity]) => {
      ec.globalCompositeOperation = 'source-over'; ec.clearRect(0, 0, edge.width, edge.height); ec.drawImage(mask, 0, 0);
      ec.globalCompositeOperation = 'destination-out'; ec.drawImage(mask, x * mask.width / width, y * mask.height / height);
      ec.globalCompositeOperation = 'source-in'; ec.fillStyle = color; ec.fillRect(0, 0, edge.width, edge.height);
      ctx.globalAlpha = opacity; ctx.drawImage(edge, 0, 0);
    });
    ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
    return finish;
  }
  return Object.freeze({ metalColor, lightSurface, renderMetallic });
});
